module.exports = __webpack_public_path__ + "static/img/office_2.48e58ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/recruit_2021/welfare/office_2.png
// module id = +51F
// module chunks = 0